import React, { useEffect, useState, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact'
import Loader from '../common/loaderapp';
import Detalle from './detalle'

const Bolsa = () => {

    const [pag_actualizar, setPag_actualizar] = useState(-1);
    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState([]);

    useEffect(() => {
        fetch('/p_bolsa', {headers: {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(res => {
            setDatos(res)
            setLoad(true)
        })
        .catch(err => console.log('Error:',err))
    }, [pag_actualizar]);

    const cabecera = [
        // { Header: <b>ID</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'400', show:false },
        { Header: <b>Puesto</b>, accessor: 'PUESTO', style: { textAlign: 'center'}, width:'400', show:true },
        { Header: <b>Ubicación</b>, accessor: 'UBICACION', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Estatus</b>, accessor: 'VISIBLE', style: { textAlign: 'center'}, width:'160', editable:true , show:true},
        { Header: <b>Fecha</b>, accessor: 'FECHA_ALTA', style: { textAlign: 'center'}, width:'110', editable:true , show:true},
    ];

    const agregar=()=>setPag_actualizar(0)
    const detalle_dato=(dato)=>{setPag_actualizar(dato.ID)}
    
    return (
        <Fragment>
            <Breadcrumb parent="Inicio" title="Bolsa de trabajo" />
            {
                load ?
                    (pag_actualizar == -1) ?
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="card-body datatable-react">
                                    <Tablereact
                                        myData={datos}
                                        cabecera={cabecera}
                                        pageSize={10}
                                        paginacion={true}
                                        buscador='Buscar'
                                        detalle={detalle_dato}
                                        boton={{text:'Agregar',function:agregar}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <Detalle pag_actualizar={pag_actualizar} setPag_actualizar={setPag_actualizar}/>
                :
                <Loader/>
            }
        </Fragment>
    );

}
 
export default Bolsa;